import jsBarcode from 'jsbarcode';
import {BarcodeImage} from './CreateBarcodesInterfaces';

export const createPrintableBarcodeHtml = (barcode: BarcodeImage): string => {
  return `
  <div class="printable-barcode-page">
    <div class="printable-barcode-container">
      <img src="data:image/svg+xml;base64,${barcode.svg}" alt="Flexe"/>
    </div>
    <p class="printable-barcode-text">${barcode.text}</p>
  </div>
`;
};

export const generatePrintableHtml = (barcodes: BarcodeImage[], printCssUrl: string): string => {
  const barcodeHtml = barcodes.map(createPrintableBarcodeHtml).join('');
  return `
    <html>
      <head>
        <title>Barcodes</title>
        <link rel="stylesheet" href="${printCssUrl}">
      </head>
      <body>
        ${barcodeHtml}
      </body>
    </html>
  `;
};

export const generateBarcodeSvgString = (barcodeText: string): string => {
  const svg = document.createElement('svg');
  jsBarcode(svg, barcodeText, {
    format: 'CODE128',
    displayValue: false
  });
  return btoa(svg.outerHTML);
};
